import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LoadingIndicator from '../ui/LoadingIndicator';

const API_URL = 'https://pandoras-box.salew-bot.ru';
const REF_CLAIM_STORAGE_KEY = 'salew:pendingRefClaimToken';

const ReferralLinkPage = () => {
  const navigate = useNavigate();
  const { refCode } = useParams();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const startClaim = async () => {
      const normalizedCode = String(refCode || '').trim();
      if (!normalizedCode) {
        setError('Реферальный код не найден');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/referral/claim/start`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ref_code: normalizedCode }),
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data?.detail || 'Не удалось обработать реферальную ссылку');
        }

        const claimToken = String(data?.claim_token || '').trim();
        if (!claimToken) {
          throw new Error('Сервер не вернул claim token');
        }

        try {
          window.localStorage.setItem(REF_CLAIM_STORAGE_KEY, claimToken);
        } catch (storageError) {
          console.warn('Не удалось сохранить claim token в localStorage:', storageError);
        }

        if (!cancelled) {
          navigate(`/login?ref_claim=${encodeURIComponent(claimToken)}`, { replace: true });
        }
      } catch (claimError) {
        if (!cancelled) {
          setError(claimError.message || 'Не удалось обработать реферальную ссылку');
        }
      }
    };

    startClaim();
    return () => {
      cancelled = true;
    };
  }, [navigate, refCode]);

  if (!error) {
    return <LoadingIndicator />;
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-3 text-center">
      <h4 className="mb-2">Ошибка реферальной ссылки</h4>
      <p className="mb-3">{error}</p>
      <Button onClick={() => navigate('/login', { replace: true })}>
        Перейти ко входу
      </Button>
    </div>
  );
};

export default ReferralLinkPage;
